import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { useEffect, useState } from "react"
import BranchType from "../../interfaces/branch";
import Branch from "./Branch";
import axios from "axios";
import IResponse from "../../interfaces/response";

export default function Branches() {
    const [branches, setBranches] = useState<BranchType[]>([]);

    useEffect(() => {
        axios<IResponse<BranchType[]>>({
            url: "branch",
            loading: true,
        }).then(res => {
            if (res.data.success) {
                setBranches(res.data.data);
            }
        })
    }, []);
    return (
        <Grid container spacing={4}>
            {branches && branches.map(branch => (
                <Grid xs={12} md={6} key={branch.id}>
                    <Branch branch={branch} />
                </Grid>
            ))}
        </Grid>
    )
}
